import React from "react";
import { Link } from "react-router-dom";
import "./ButtonGroup.scss";

const ButtonGroup: React.FC = () => {
  return (
    <div className="ButtonGroup">
      {/* <button type="button">이전</button> */}
      <Link to={process.env.NODE_ENV === "development" ? "/" : "/board"}>
        <button type="button">목록</button>
      </Link>

      {/* <button type="button">다음</button> */}
    </div>
  );
};

export default ButtonGroup;
